let autoPlayInterval;
let activeIndex = 0;
const autoPlayDelay = 5000;
let isAutoPlayActive = false;

function handleFAQClick(clickedElement) {
    if (clickedElement.classList.contains('active')) {
        return;
    }

    const faqs = document.querySelectorAll('.faq-item');
    const newImageSrc = clickedElement.getAttribute('data-img');
    const imageElement = document.getElementById('faqImage');
    const answerContainer = document.getElementById('faqAnswerContainer');

    faqs.forEach((faq) => faq.classList.remove('active'));
    clickedElement.classList.add('active');

    imageElement.classList.remove('loaded');
    setTimeout(() => {
        imageElement.src = newImageSrc;
        imageElement.onload = () => {
            imageElement.classList.add('loaded');
        };
    }, 300);

    answerContainer.querySelector('.faq-answer').classList.remove('active');
    setTimeout(() => {
        answerContainer.querySelector('.faq-answer').innerHTML = clickedElement.querySelector('.faq-answer').innerHTML;
        answerContainer.querySelector('.faq-answer').classList.add('active');
    }, 300);

    activeIndex = Array.from(faqs).indexOf(clickedElement);
    resetAutoPlay();
}

function autoPlayFAQ() {
    const faqs = document.querySelectorAll('.faq-item');
    const totalFAQs = faqs.length;

    activeIndex = (activeIndex + 1) % totalFAQs;

    faqs[activeIndex].click();
}
function resetAutoPlay() {
    clearInterval(autoPlayInterval);
    autoPlayInterval = setInterval(autoPlayFAQ, autoPlayDelay);
}

function startAutoPlay() {
    if (isAutoPlayActive) {
        return;
    }
    isAutoPlayActive = true;
    resetAutoPlay();
}

document.addEventListener('DOMContentLoaded', function () {
    const faqSection = document.querySelector('.faq-container');
    const firstFAQItem = document.querySelector('.faq-item');

    if (firstFAQItem) {
        firstFAQItem.click();
    }

    if (faqSection) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        startAutoPlay();
                    } else {
                        clearInterval(autoPlayInterval);
                        isAutoPlayActive = false;
                    }
                });
            },
            {
                threshold: 0.5,
            }
        );

        observer.observe(faqSection);
    } else {
        console.error('FAQ section not found');
    }
});